import React from "react";
import { Checkbox, Box, TextField, DialogContent, DialogTitle, Dialog, Button, FormControlLabel, Grid } from '@material-ui/core';

class PopUp extends React.Component {
    render(){
        return (
        <Dialog
        disableBackdropClick={this.props.disableDefaultPopupExit?true:false}
        disableEnforceFocus={this.props.disableDefaultPopupExit?true:false}
        maxWidth="lg"
        fullWidth={true}
        open={this.props.openStateVariable}
        onClose={this.props.onCloseFunction}>
            <Box borderColor="#d81a21" border={0.5}>
                {this.props.title?<DialogTitle className="dialogTitle" id="form-dialog-title">{this.props.title}</DialogTitle>:<></>}
                <DialogContent className="dialogContent">
                    <Box display="flex" flexDirection={this.props.largeScreen ? "row":"column"} justifyContent="space-around">
                        {this.props.dialogContent?this.props.dialogContent:<></>}
                    </Box>
                </DialogContent>
            </Box>
        </Dialog>
        )
    }
}

export default PopUp;